import { render } from "./EditVue.vue?vue&type=template&id=9c875528"
import script from "./EditVue.vue?vue&type=script&lang=js"
export * from "./EditVue.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__